import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import UPLOAD from "../../../../components/uoload/upload";
import { Col, Row } from "antd";
import { Uploder } from "../../../../utils/utils";
import INPUT from './../../../../components/input/input';
import SELECT from "./../../../../components/select/select";
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";

export default function AboutAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false })
    const [user, setUser] = useState({ "bloodGroup": "O+" });
    const bloodGroups = [{ "name": "O+", "value": "O+" }, { "name": "O-", "value": "O-" }, { "name": "A+", "value": "A+" }, { "name": "A-", "value": "A-" }, { "name": "B+", "value": "B+" }, { "name": "B-", "value": "B-" }, { "name": "AB+", "value": "AB+" }, { "name": "AB-", "value": "AB-" }]
    const [images, setImages] = useState([]);
    const [profileImage, setProfileImage] = useState({ "id": null, "link": null })


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/athlete-get-about-me/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setUser(response.data)
                    if (response.data.profile != undefined) {
                        setProfileImage({ "id": response.data.profile._id, "link": `${url}${response.data.profile.path}` })
                    }
                    var x = [];
                    for (const iterator of response.data.bloodTest) {
                        x.push(
                            { "id": iterator._id, "link": `${url}${iterator.path}` }
                        )
                        setImages(x)

                    }

                    setLoading({ ...loading, 1: false })

                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 1: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [])


    const submitAbout = () => {
        if (user.weight != "" && user.height != "") {
            var data = user;
            var x = [];
            for (const iterator of images) {
                x.push(iterator.id)
            }
            data = { ...data, "bloodTest": x }
            data = { ...data, "profile": profileImage.id != null ? profileImage.id : "" }

            setLoading({ ...loading, 1: true });
            Axios.patch(`${url}users/athlete-about-me/${userId}`, data)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        GreenNotif(response.message);
                        setLoading({ ...loading, 1: false });
                        setUser({ "bloodGroup": "O+" })
                        props.pager(1)
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 1: false });
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 1: false })
                });
        } else {
            RedNotif("لطفا تمام موارد را وارد کنید هیچ فیلدی نباید خالی باشد")
        }
    }


    const upload = async (e) => {
        var res = await Uploder(e, "bloodTest")
        if (res.status == 200 || res.status == 201) {
            setLoading({ ...loading, 2: false })
            var x = images;
            x.push({ "id": res.data._id, "link": `${url}${res.data.path}` })
            setImages(x)

        }
    }


    const uploadProfile = async (e) => {
        var rsr = await Uploder(e, "profile")
        if (rsr.status == 200 || rsr.status == 201) {
            setLoading({ ...loading, 3: false })
            setProfileImage({ "id": rsr.data._id, "link": `${url}${rsr.data.path}` })
        }
    }

    const deleteImage = (item) => {
        var x = [];

        images.filter(function (obj) {
            if (obj.id !== item.id) {
                x.push(obj)
            }
        });

        setImages(x)
    }


    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>اطلاعات زیر را وارد نمایید:</p>
                    </Col>
                </Row>

                <Row style={{ marginBottom: '18px', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ margin: "15px !important" }}>آپلود عکس </p>
                        <div style={{ width: "250px", height: '150px', margin: "10px 0" }}>
                            <UPLOAD
                                label={"up2"}
                                accept={".png,.jepg,.jpg"}
                                click={(e) => {
                                    setLoading({ ...loading, 3: true })
                                    uploadProfile(e)
                                }} loading={loading[3]} defultImage={profileImage.link} />
                        </div>
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>وزن:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <INPUT
                            type={"number"}
                            i={(e) => setUser({ ...user, "weight": e })}
                            value={user.weight != undefined && user.weight != null && user.weight != "0" ? user.weight : ""}

                        />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>قد:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <INPUT
                            type={"number"}
                            i={(e) => setUser({ ...user, "height": e })}
                            value={user.height != undefined && user.height != null && user.height != "0" ? user.height : ""}
                        />
                    </Col>
                </Row>

                <Row gutter={10}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginRight: "18px" }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>گروه خونی:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <SELECT
                            click={(e) => setUser({ ...user, "bloodGroup": e })}
                            items={bloodGroups}
                            value={user.bloodGroup} />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} />
                </Row>

                <Row style={{ marginBottom: '2px', marginTop: '32px', marginRight: '12px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>آزمایش خون</p>
                    </Col>
                </Row>

                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <div style={{ width: "250px", height: '150px', marginTop: '12px', marginRight: '8px' }}>
                            <UPLOAD
                                label={"up1"}
                                accept={".png,.jepg,.jpg"}
                                click={(e) => {
                                    setLoading({ ...loading, 2: true })
                                    upload(e)
                                }} loading={loading[2]} />

                        </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row>
                            {
                                images.map((itm, idx) =>
                                    <Col key={idx} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <img src={itm.link} style={{ width: "250px", height: '150px', margin: '12px' }} onClick={() => deleteImage(itm)} />
                                    </Col>

                                )
                            }
                        </Row>
                    </Col>
                </Row>


                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => { submitAbout() }}

                            text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(1)} text="رد کردن" type={"cancel"} />

                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }


}
